/**
 * Проверяет доступ ученика к курсу
 * @param {string} childrenId - ID ученика
 * @param {string} directionId - ID направления
 * @param {'course'|'lessons'|'homework'} [context] - какой запрет после окончания демо-доступа учитывать
 * @returns {Promise<boolean|'error'>} true - доступ открыт, false - доступ закрыт, 'error' - ошибка
*/

import { directionOrdersApi } from "@/api"
export const isCourseAccessGranted = async ({childrenId, directionId, context}) => {
    try {
        const res = await directionOrdersApi.checkDisabled({
            params: {
                childId: childrenId,
                directionId: directionId,
                ...(context && { context }),
            }
        })

        if(res?.data?.data == 'true'){
            return false;
        }
        if(res?.data?.data == 'false'){
            return true;
        }
        return 'error';
    } catch (error) {
        return 'error';
    } 
}